export default {
    url: '/level/:id',
    template: '<user-group-detail-level level="vm.level"/>',
    resolve: {
        level (ClassifierResource, $stateParams) {
            return ClassifierResource.get({ id: $stateParams.id }).$promise;
        }
    },
    controller (level) {
        this.level = level;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/group/detail/level/index.js